import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Spinner } from "@phosphor-icons/react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await exchangeGoogleSession(decodeURIComponent(m[1]));
        toast.success("Signed in with Google");
        // Clear hash, then go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogleSession, location, navigate]);

  return (
    <div className="min-h-screen w-full bg-slate-50 flex items-center justify-center">
      <div className="flex items-center gap-3 text-slate-500 text-sm font-mono-ibm">
        <Spinner size={18} weight="bold" className="animate-spin" />
        Finalizing sign-in…
      </div>
    </div>
  );
}
